import * as React from 'react'

// libs
import { createUseStyles } from "react-jss";
import { Portal } from 'react-portal';

// blocks
import Appbar from './Appbar'
import UiButton from './UiButton'
import PackageUpdate from './PackageUpdate'


const useStyles = createUseStyles({
  appbar: {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 20,
    backgroundColor: '#000',
  },
})


interface Props {
  show: boolean
}

export default function Toolbar({ show }: Props) {

  // refs
  const refAppbar = React.useRef(null)

  // styles
  const styles = useStyles();

  // render
  const node = typeof document !== 'undefined' && document.getElementById('playerUI')


  // Update position for ui buttons
  React.useEffect(() => {
    const appbarHeight = refAppbar.current.clientHeight + 'px'
    const doc = document.documentElement
    doc.style.setProperty("--appbar-height", appbarHeight);

    const apply = (id: string) => {
      const el = document.getElementById(id)
      if (el) el.style.top = appbarHeight
    }

    apply('controls')
    apply('connection')

  }, [])


  return (
    <>
      <Portal node={node}>
        <div className={styles.appbar} ref={refAppbar}>

          <PackageUpdate />
          {show && (
            <Appbar />
          )}

        </div>
      </Portal>
      {show && (
        <UiButton />
      )}
    </>
  )
}